var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconParkOutlineWebPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 33 32",
    width: 33,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m27.8327 5.33398h-22.66668c-1.10457 0-2 .89543-2 2v17.33332c0 1.1046.89543 2 2 2h22.66668c1.1046 0 2-.8954 2-2v-17.33332c0-1.10457-.8954-2-2-2z",
    stroke: "#0923e6",
    strokeLinejoin: "round",
    strokeWidth: 1.64
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m3.16602 7.33398c0-.53043.21071-1.03914.58578-1.41421s.88378-.58579 1.41422-.58579h22.66668c.5304 0 1.0391.21072 1.4142.58579s.5858.88378.5858 1.41421v6.00002h-26.66668z",
    stroke: "#0923e6",
    strokeWidth: 1.64
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0923e6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.83333 9.33464c0-.73638.59696-1.33334 1.33334-1.33334s1.33333.59696 1.33333 1.33334c0 .73636-.59695 1.33336-1.33333 1.33336s-1.33334-.597-1.33334-1.33336z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.83333 9.33464c0-.73638.59697-1.33334 1.33337-1.33334.7363 0 1.3333.59696 1.3333 1.33334 0 .73636-.597 1.33336-1.3333 1.33336-.7364 0-1.33337-.597-1.33337-1.33336z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParkOutlineWebPage);
export default __webpack_public_path__ + "static/media/icon-park-outline_web-page.250102042a6142ade3eec4091f82fdb7.svg";
export { ForwardRef as ReactComponent };